import React from "react";
import { FullAddress } from "./FullAddress";

/**
 * Build full physical address as a component
 *
 * @param sameMailAndPhysicalAddress
 * @param address
 * @param address2
 * @param city
 * @param state
 * @param zip
 * @param attn
 * @param countryId if provided, display country flag
 */
export function FullPhysicalAddress({
  address,
  address2,
  city,
  state,
  zip,
  countryId,
  hasAddress,
  sameMailAndPhysicalAddress,
}: {
  address: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  countryId?: string | null;
  hasAddress?: boolean;
  sameMailAndPhysicalAddress: boolean;
}) {
  if (sameMailAndPhysicalAddress && !hasAddress) {
    return null;
  }
  if (sameMailAndPhysicalAddress) {
    return <i>Same as mailing address</i>;
  }
  return (
    <FullAddress
      address={address}
      address2={address2}
      city={city}
      state={state}
      zip={zip}
      attn={null}
      countryId={countryId}
    />
  );
}
